/* eslint-disable */
import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'q-bank-update-page',
  components: {
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data() {
    return {
      name: '',
      instruction: '',
      create_datetime:'',
      end_datetime:'',
      submitted:false,
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      minDatetime:new Date().toISOString(),
    }
  },
  computed: {
  },
  mounted() {
    this.$store.dispatch('getQBankInfoByIdAction', {id:this.$route.params.qbankId}).then((res) => {
      this.name = res.data.data.results.name
      this.create_datetime = res.data.data.results.start_time
      this.instruction = res.data.data.results.instruction
      this.end_datetime = res.data.data.results.end_time
    })
  },
  methods: {
    validateUpdateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          let data = {
            name: this.name,
            instruction: this.instruction,
            start_time:this.create_datetime,
          }
          if(this.end_datetime != null && this.end_datetime != ''){
            data.end_time = this.end_datetime;
          }else{
            data.end_time = null
          }
          this.$store.dispatch('updateQBankInfoAction', {data:{data:data,id:this.$route.params.qbankId}})
          .then((res) => {     
            toast.success("The request has been successfully submitted");  
            this.$router.push({ name: 'inviewQbankList'})
            this.submitted = false
          })
          .catch((err) => { 
            console.log(err)
            // toast.error(err.data.user_msg || err.data.msg); 
            this.submitted = false  
          })
          return
        }
      });
    },
  },
  watch: {
  }
}